import mixins from "vue-typed-mixins";
import { gtmMixin } from "@/mixins";
import { TextField, Button, Alert, Icon, Modal } from "@/components";
export default mixins(gtmMixin).extend({
    components: {
        Modal,
        TextField,
        Button,
        Alert,
        Icon,
    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        submitting: {
            type: Boolean,
            default: false,
        },
        success: {
            type: Boolean,
            default: false,
        },
        error: {
            type: String,
            default: "",
        },
    },
    data: () => ({
        isOpen: false,
        email: "",
        rules: {
            email: "required|email",
        },
        items: [
            {
                text: "SD, SMP, SMA",
                url: "https://referensi.data.kemdikbud.go.id/index11.php",
                linkName: "nspn_sd_smp_sma",
            },
            {
                text: "PAUD",
                url: "https://referensi.data.kemdikbud.go.id/index21.php",
                linkName: "nspn_paud",
            },
            {
                text: "DIKMAS (LKP, PKBM, SKB, PONPES)",
                url: "https://referensi.data.kemdikbud.go.id/index31.php",
                linkName: "nspn_dikmas",
            },
            {
                text: "SLB, TKLB, SDLB, SMPLB, SMLB",
                url: "https://referensi.data.kemdikbud.go.id/index41.php",
                linkName: "nspn_slb",
            },
        ],
    }),
    watch: {
        value: {
            immediate: true,
            handler(val) {
                this.isOpen = val;
            },
        },
        isOpen(val) {
            this.$emit("input", val);
        },
    },
    methods: {
        onSubmit() {
            this.$emit("submit", this.email);
        },
        close() {
            this.$emit("close");
            this.$emit("input", false);
        },
        onClick(item) {
            this.gtmClickLink(item.linkName);
        },
    },
    beforeDestroy() {
        this.email = "";
    },
});
